export enum BlockName {
    accessForRequester = 'accessForRequester',
    activateCaroQuestionnaireOrBodyWeightMeasurement = 'activateCaroQuestionnaireOrBodyWeightMeasurement',
    assignAnyActivityPerformer = 'assignAnyActivityPerformer',
    assignToActivityPerformer = 'assignToActivityPerformer',
    assignToGraderPoolProvider = 'assignToGraderPoolProvider',
    assignToPreviousActivityPerformer = 'assignToPreviousActivityPerformer',
    assignToPreviousActivityPerformerOrganization = 'assignToPreviousActivityPerformerOrganization',
    assignToProcessActorOrganization = 'assignToProcessActorOrganization',
    assignToRequester = 'assignToRequester',
    bariatricsNotifyProcessActor = 'bariatricsNotifyProcessActor',
    cancelHolterExamination = 'cancelHolterExamination',
    cancelProcess = 'cancelProcess',
    cancelProcessWorkflowSteps = 'cancelProcessWorkflowSteps',
    canPerformActivity = 'canPerformActivity',
    checkBooleanInActivity = 'checkBooleanInActivity',
    checkCaroInactivityNextStep = 'checkCaroInactivityNextStep',
    checkCaroPatientCreated = 'checkCaroPatientCreated',
    checkConditions = 'checkConditions',
    checkEveryStepHasStatus = 'checkEveryStepHasStatus',
    checkForTruthy = 'checkForTruthy',
    checkNotEmpty = 'checkNotEmpty',
    checkSomeConditions = 'checkSomeConditions',
    checkSomeStepsHaveStatus = 'checkSomeStepsHaveStatus',
    checkStringValueInActivity = 'checkStringValueInActivity',
    closeProcess = 'closeProcess',
    completeProcess = 'completeProcess',
    createCaroPatient = 'createCaroPatient',
    createCompletedActivity = 'createCompletedActivity',
    createCompletedResendQuestionnaires = 'createCompletedResendQuestionnaires',
    createEvidencioPatient = 'createEvidencioPatient',
    createExternalReferralLetter = 'createExternalReferralLetter',
    createMraReferralLetter = 'createMraReferralLetter',
    createOsasNoTreatmentTaskBlock = 'CreateOsasNoTreatmentTaskBlock',
    createOsasTaskForChosenTreatment = 'createOsasTaskForChosenTreatment',
    createPatientTask = 'createPatientTask',
    createReferralLetter = 'createReferralLetter',
    createTherapielandRequest = 'createTherapielandRequest',
    dummyAction = 'dummyAction',
    dummyStep = 'dummyStep',
    dummySystemAction = 'dummySystemAction',
    emailEvidencioQuestionnaireToPatient = 'emailEvidencioQuestionnaireToPatient',
    emailExaminationToPerformer = 'emailExaminationToPerformer',
    fixedIntervalScheduler = 'fixedIntervalScheduler',
    hearingLossCreateRecipeLetter = 'hearingLossCreateRecipeLetter',
    holterAssignToHomeHolterOrganization = 'holterAssignToHomeHolterOrganization',
    insertInGroupMeetingPatientsTable = 'insertInGroupMeetingPatientsTable',
    insertInPatientConsentsTable = 'insertInPatientConsentsTable',
    insertInProcessActorsTable = 'insertInProcessActorsTable',
    insertPoliclinicOrganizationInProcessActorsTable = 'insertPoliclinicOrganizationInProcessActorsTable',
    intervalWeeksBasedOnServiceActivityScheduler = 'intervalBasedOnServiceActivityScheduler',
    invitePatientToBrightPlan = 'invitePatientToBrightPlan',
    manualStart = 'manualStart',
    osasCreateExternalReferralLetter = 'osasCreateExternalReferralLetter',
    pauseProcess = 'pauseProcess',
    percentageYesOrNo = 'percentageYesOrNo',
    performActivity = 'performActivity',
    receiveEvidencioGradingResult = 'receiveGradingResult',
    receiveEvidencioPrickTestMeasurements = 'receivePrickTestMeasurements',
    receiveEvidencioQuestionnaireStatus = 'receiveEvidencioQuestionnaireStatus',
    registerCloudPatPatient = 'registerCloudPatPatient',
    reminderEmailEvidencioQuestionnaireToPatient = 'reminderEmailEvidencioQuestionnaireToPatient',
    reminderEmailToPerformer = 'reminderEmailToPerformer',
    resumeProcess = 'resumeProcess',
    saveCaroFollowUpBodyWeightMeasurements = 'saveCaroFollowUpBodyWeightMeasurements',
    saveCaroQuestionnaireResponse = 'saveCaroQuestionnaireResponse',
    saveEvidencioQuestionnaireResponse = 'saveEvidencioQuestionnaireResponse',
    saveProcessQuestionnaireResponse = 'saveProcessQuestionnaireResponse',
    saveResponseBody = 'saveResponseBody',
    sendEmailAfterCloudPatSubscriptionUpdate = 'sendEmailAfterCloudPatSubscriptionUpdate',
    sendEmailToGeneralPractitioner = 'sendEmailToGeneralPractitioner',
    sendEmailToPatient = 'sendEmailToPatient',
    sendEmailToPatientTaskPerformer = 'sendEmailToPatientTaskPerformer',
    sendEmailToRequester = 'sendEmailToRequester',
    sendEmailToRequesterBasedOnNotificationSettings = 'sendEmailToRequesterBasedOnNotificationSettings',
    sendEmailToTaskPerformer = 'sendEmailToTaskPerformer',
    sendEmailToTaskPerformerBasedOnNotificationSettings = 'sendEmailToTaskPerformerBasedOnNotificationSettings',
    sendExaminationRecorderEmail = 'sendExaminationRecorderEmail',
    sendHolterReadOutPendingUploadReminder = 'sendHolterReadOutPendingUploadReminder',
    sendZorgMail = 'sendZorgMail',
    sendZorgmailToGeneralPractitioner = 'sendZorgmailToGeneralPractitioner',
    setRequesterFromCareProvider = 'setRequesterFromCareProvider',
    setRequesterFromStarter = 'setRequesterFromStarter',
    startProcessFromExistingProcess = 'startProcessFromExistingProcess',
    updateCaroPatientFromActivityData = 'updateCaroPatientFromActivityData',
    updateCaroPatientFromStep = 'updateCaroPatientFromStep',
    updateGroupMeetingPatient = 'updateGroupMeetingPatient',
    updatePatientFromActivityData = 'updatePatientFromActivityData',
    updatePatientGeneralPractitionerFromStarter = 'updatePatientGeneralPractitionerFromStarter',
    uploadRecordingToAnalysisParty = 'uploadRecordingToAnalysisParty',
    upsertInPatientGeneralPractitionersTable = 'upsertInPatientGeneralPractitionersTable',
    userChoice = 'userChoice',
    waitForAll = 'waitForAll',
    waitForDateTime = 'waitForDateTime',
}
